import type { RouteObject } from 'react-router'
import { CalendarPage } from './Calendar'
import { CasePage } from './Case'
import { CompanyPage } from './Company'
import { DashboardPage } from './Dashboard'
import { EngagementsPage } from './Engagements'
import { MeetingPage } from './Meeting'
import { MethodologyPage } from './Methodology'
import { PortfolioPage } from './Portfolio'
import { ReportsPage } from './Reports'
import { RequestsPage } from './Requests'
import { UpdatesPage } from './Updates'

/**
 * Routes under /app. To add a screen: create `<Screen>.tsx` in this folder, add a line
 * here, and (for top-level screens) an entry in ./nav.ts. Detail pages such as
 * `companies/:id` need only the route.
 */
export const appRoutes: RouteObject[] = [
  { index: true, element: <DashboardPage /> },
  { path: 'portfolio', element: <PortfolioPage /> },
  { path: 'companies/:id', element: <CompanyPage /> },
  { path: 'updates', element: <UpdatesPage /> },
  { path: 'engagements', element: <EngagementsPage /> },
  { path: 'engagements/:id', element: <CasePage /> },
  // Dashboard and published-update links use /app/cases/:id.
  { path: 'cases/:id', element: <CasePage /> },
  { path: 'calendar', element: <CalendarPage /> },
  { path: 'meetings/:id', element: <MeetingPage /> },
  { path: 'requests', element: <RequestsPage /> },
  { path: 'reports', element: <ReportsPage /> },
  { path: 'methodology', element: <MethodologyPage /> },
]
